import React from 'react';
import './CookieMonster.css';

export default class CookieMonster extends React.Component {
  state: Readonly<{ display: boolean }> = {
    display: false
  }

  componentDidMount() {
    const agreed = window.localStorage.getItem("cookie-ok");
    if (!agreed) {
      this.setState({ display: true });
    }
  }

  agree() {
    window.localStorage.setItem("cookie-ok", `${Date.now()}`);
    this.setState({ display: false });
  }

  render(): React.ReactNode {
    const div = (
      <div className="cookie-monster">
        <p className="align-right"><span className="cookie-close" onClick={() => this.agree()}>×</span></p>
        Na těchto stránkách nevyužíváme žádné zbytečné nebo reklamní cookies.<br />
        Jediné, co sbíráme, jsou informace o návštěvnosti těchto stránek. <br />
        Děkujeme za pochopení.<br />
        <span className="cookie-ok" onClick={() => this.agree()}>OK</span>
      </div>
    );
    return this.state.display ? div : null;
  }
}